import React, { useState, useEffect } from 'react';
import { Card, Row, Col, message } from 'antd';
import { getExploitationInfo, updateSupportedAnalysis } from "../../Utils/exploitations/exploitations";
import { FaWater, FaFlask, FaLeaf } from 'react-icons/fa';
import { GiGroundSprout } from 'react-icons/gi';

const analysisTypes = [
    { key: 'sol', label: 'Sol', icon: GiGroundSprout, color: '#faad14' },
    { key: 'eau', label: 'Eau', icon: FaWater, color: '#1890ff' },
    { key: 'solution-sol', label: 'Solution du sol', icon: FaFlask, color: '#eb2f96' },
    { key: 'feuilles', label: 'Feuilles', icon: FaLeaf, color: '#52c41a' }
];

const SupportedAnalysis = ({ exploitationId }) => {
    const [selectedAnalyses, setSelectedAnalyses] = useState([]);

    useEffect(() => {
        const fetchExploitationData = async () => {
            try {
                const data = (await getExploitationInfo(exploitationId)).data;
                if (data.supported_analysis) {
                    let analysis = data.supported_analysis?.split(',');
                    analysis = analysis.filter((item) => item !== '' && item !== ' ');
                    setSelectedAnalyses(analysis);
                }
            } catch (error) {
                console.error('Error fetching exploitation data:', error);
            }
        };

        fetchExploitationData();
    }, [exploitationId]);

    const toggleAnalysis = async (analysisId) => {
        let updatedAnalyses;
        if (selectedAnalyses.includes(analysisId)) {
            updatedAnalyses = selectedAnalyses.filter(key => key !== analysisId);
        } else {
            updatedAnalyses = [...selectedAnalyses, analysisId];
        }

        setSelectedAnalyses(updatedAnalyses);

        try {
            const payload = updatedAnalyses.length == 0 ? ' ' : updatedAnalyses.join(',');
            await updateSupportedAnalysis(exploitationId, { supported_analysis: payload });

            message.success('Analyses prises en charge mises à jour avec succès');
        } catch (error) {
            console.error('Error updating supported analysis:', error);
            message.error('Erreur lors de la mise à jour des analyses prises en charge');
        }
    };

    return (
        <div className=" p-8">
            <h2 className="text-4xl font-bold pl-4 mb-6 text-gray-800">Analyses Prises en Charge</h2>
            <Row gutter={[32, 32]} className="p-4">
                {analysisTypes.map((analysis) => (
                    <Col xs={24} sm={12} key={analysis.key}>
                        <Card
                            hoverable
                            className={`
                                transition-all duration-300 ease-in-out
                                transform hover:-translate-y-1 hover:shadow-lg
                                ${selectedAnalyses.includes(analysis.key) 
                                    ? 'bg-opacity-90 text-white shadow-md' 
                                    : 'bg-white hover:bg-gray-50'
                                }
                            `}
                            style={{
                                backgroundColor: selectedAnalyses.includes(analysis.key) ? analysis.color : '',
                                borderColor: selectedAnalyses.includes(analysis.key) ? analysis.color : '#d9d9d9'
                            }}
                            onClick={() => toggleAnalysis(analysis.key)}
                        >
                            <div className="flex items-center space-x-4">
                                <div className={`
                                    p-3 rounded-full
                                    ${selectedAnalyses.includes(analysis.key) 
                                        ? 'bg-white bg-opacity-30' 
                                        : 'bg-gray-100'
                                    }
                                `}>
                                    <analysis.icon 
                                        size={45} 
                                        color={selectedAnalyses.includes(analysis.key) ? 'white' : analysis.color}
                                    />
                                </div>
                                <div>
                                    <h3 className={`
                                        text-3xl font-semibold
                                        ${selectedAnalyses.includes(analysis.key) ? 'text-white' : 'text-gray-800'}
                                    `}>
                                        {analysis.label}
                                    </h3>
                                    <p className={`
                                        text-lg
                                        ${selectedAnalyses.includes(analysis.key) ? 'text-white text-opacity-80' : 'text-gray-600'}
                                    `}>
                                        {selectedAnalyses.includes(analysis.key) ? 'Sélectionné' : 'Cliquer pour sélectionner'}
                                    </p>
                                </div>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default SupportedAnalysis;